import React from "react";
import Box from "../Box.js";

export default class TrudatOneTwo extends React.Component {
  render() {
    return (
      <div className="hp__block hp__block--one-two container text-center">
        <div className="row hp__block__row hp__block__row--first">
          <div className="hp__block__row-wrapper col-md-6">
            <Box
              {...this.props}
              type="tetragon"
              id="b1"
              settings={this.props.settings.b1}
              classes="hp__box__background-tetragon-big hp__box__tetragon-first"
            />
          </div>
          <div className="hp__block__row-wrapper col-md-6">
            <Box
              {...this.props}
              type="tetragon"
              id="b2"
              settings={this.props.settings.b2}
              classes="hp__box__background-tetragon-wide  hp__box__tetragon-second"
            />
            <Box
              {...this.props}
              type="tetragon"
              id="b3"
              settings={this.props.settings.b3}
              classes="hp__box__background-tetragon-wide  hp__box__tetragon-third"
            />
          </div>
        </div>
      </div>
    );
  }
}
